// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3ixQB","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__Ps_XC"};